import CookieBanner from './CookieBanner';

export default CookieBanner;



// WEBPACK FOOTER //
// ./src/components/CookieBanner/index.js